<template>
  <div class="my" :class="{ 'not-expanded': !this.expanded }">
    <header class="my-header">
      <span
        v-if="searchTextValue"
        @click="deleteValue"
        class="my-header-icon-remove filter-trash cursor_pointer"
      >
        <mdicon name="trash-can-outline" size="18" />
      </span>
      <p @click="toggleCardState" class="my-header-title pl-1">
        <span
          class="text-primary pr-1"
          :class="{ 'ml-4': searchTextValue }"
          v-b-tooltip.hover
          :title="header.search_scope"
        >
          <mdicon
            v-if="header.search_scope"
            name="information"
            class="information-icon"
            size="20"
          />
          <mdicon v-else name="checkbox-blank-circle-outline" size="20" />
        </span>
        <span class="pr-1">
          {{ header.key_filter_caption }}
        </span>
      </p>
      <span @click.prevent="toggleCardState" class="my-header-icon">
        <span class="icon">
          <i class="fa fa-angle-up"></i>
        </span>
      </span>
    </header>

    <div class="my-content">
      <div class="content p-2">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              v-model="searchTextValue"
              :placeholder="$lang.search.place_holder"
              @keydown.enter="searchText"
            >
            </b-form-input>
            <b-input-group-prepend>
              <b-button class="btn-lightgray" @click="searchText">
                <mdicon name="magnify" size="20" />
              </b-button>
            </b-input-group-prepend>
          </b-input-group>
        </b-form-group>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    expandAll: {
      type: Boolean,
      default: false,
    },
    header: {
      type: Object,
      default: null,
    },
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      expanded: false,
      searchTextValue: this.value,
      debounceGet: null,
    };
  },
  watch: {
    searchTextValue(newValue) {
      this.searchTextValue = newValue;
    },
  },
  methods: {
    toggleCardState() {
      this.expanded = !this.expanded;
    },
    closeAll() {
      this.expanded = false;
    },
    searchText() {
      this.$emit("selected", this.searchTextValue, this.header.key_service);
    },
    deleteValue() {
      this.searchTextValue = "";
      this.$emit("selected", this.searchTextValue, this.header.key_service);
      this.expanded = false;
    },
    delaySearch() {
      if (this.debounceGet) {
        clearTimeout(this.debounceGet);
        this.debounceGet = null;
      }
      this.debounceGet = setTimeout(() => {
        this.searchText();
      }, 1000);
    },
  },
  created() {
    this.$on("closeAll", this.closeAll);
  },
  destroyed() {
    clearTimeout(this.debounceGet);
    this.debounceGet = null;
  },
};
</script>
